<script type="text/javascript">
	import MenuItem from "../FlyoutMenu/MenuItem.svelte";

	import Textfield, { Input, Textarea } from "@smui/textfield";
	import HelperText from "@smui/textfield/helper-text/index";
	import DataTable, { Head, Body, Row, Cell } from "@smui/data-table";
	import Button, { Label } from "@smui/button";

	import { onMount } from "svelte";
	import { get } from "svelte/store";
	import Icon from "../Icons/Icon";
	import Vessel from "../../Models/Vessel";
	import VesselIDType from "../../Models/Enums/VesselIDType";
	import VesselProperty from "../../Models/Enums/VesselProperty";


	import AlertType from "../../Alerts/AlertType.js";
	import AlertTypeDescriptions from "../../Alerts/AlertTypeDescriptions.js";
	import AlertsStore from "../../Alerts/Store.js";
	
	import User from "../../Branding/User"
	import Feature from "../../Branding/Feature"
	import Router from "../../Router";
	

	import MapStore from "../../Map/Store";
	import MapViewType from "../../Map/Enums/MapViewType";
	import MapDataSource from "../../Map/Enums/MapDataSource.js";
	import MapLayer from "../../Map/Enums/MapLayer.js";
	import VisibilityState from "../../Map/Enums/VisibilityState.js"

	import "./AlertList.scss";

	import StringHelper from "../../Helpers/StringHelper";
	import FilterHelper from "../../Helpers/FilterHelper";

	import MySvelteTable from "./MySvelteTable.svelte";

	const PRINT_DEBUGS = false;

	onMount(()=>{
		MapStore.actions.setViewType(MapViewType.ALERTS);
	});

	let onCellClick = (event) => {
		const columnKey = event.detail.key;
		const rowData = event.detail.row;

		const mmsi = rowData.mmsi;
		const vessel = AlertsStore.vesselGroup.find({[VesselProperty.MMSI]: mmsi});
		if (vessel) {
			if (columnKey === "target") {
				AlertsStore.vesselGroup.unfocusAll();
				AlertsStore.vesselGroup.unselectAll();
				vessel.focused = true;
				vessel.selected = true;
			}
			else {
				vessel.selected = !vessel.selected;
			}
			AlertsStore.vesselGroup.update();
		}
	};
	let onColClick = (event) => {
		$filtersUpdated = $filtersUpdated; // Make the component update to show the sort button
		$rawSelected = $rawSelected; // Make the component update to show the sort button
	};
	let clearSelected = () => {
		AlertsStore.vesselGroup.deselectAll();
		AlertsStore.vesselGroup.update();
	};
	let sortBySelected = () => {
		tableSortBy = "selected";
		tableSortOrder = -1;
	}


	let tableSortBy = "alertType";
	let tableSortOrder = 1;

	// clickCell
	let table;
	let alertVessels = [];
	let alertVesselsTableRows = [];
	const thinClass = "alertType";
	const targetClass = "target";
	let alertVesselsTableColumns = [
		{
			key: "alertType",
			title: "Type",
			value: v => v.alertType,
			sortable: true,
			renderValue:
					v => "<p title='" + AlertTypeDescriptions[v.alertType] + "'>" + v.alertType + "</p>",
			class: (v) => {
				return thinClass + ((v.selected) ? " selected" : "");
			},
			headerClass: thinClass
		},
		{
			key: "imo",
			title: "IMO",
			value: v => v.imo,
			sortable: true,
			renderValue: (v, v2) => {
				return v.imo === null?"Unknown":v.imo;
			},
			class: (v) => {
				return (v.selected) ? "selected" : "";
			},
			headerClass: "imo"
		},
		{
			key: "mmsi",
			title: "MMSI",
			value: v => v.mmsi,
			sortable: true,
			class: (v) => {
				return (v.selected) ? "selected" : "";
			},
			headerClass: "mmsi"
		},
		{
			key: "name",
			title: "Name",
			value: v => v.name,
			renderValue: v => "<span title='" + v.name + "'>" + v.name + "</span>",
			sortable: true,
			class: (v) => {
				return "name " + ((v.selected) ? "selected" : "");
			},
			headerClass: "name"
		},
		{
			key: "target",
			title: "",
			value: v => false,
			sortable: false,
			//renderValue: v => "<img alt='Focus' style='color:red;' src='" + Icon.crosshair.solid + "'/>",
			//renderValue: v => "<IconButton class='material-icons'> menu</IconButton>",
			renderValue: v => "<a class='material-icons icon'>zoom_in</a>",
			class: (v) => {
				return targetClass + ((v.selected) ? " selected" : "");
			},
			headerClass: targetClass
		},
		{
			key: "selected",
			title: "",
			hidden: true,
			value: (v) => { return (v.selected) ? 1 : 0; },
			sortable: true,
			renderValue: (v) => { return (v.selected) ? "1" : "0"; },
			class: (v) => {
				return targetClass + ((v.selected) ? " selected" : "");
			},
			headerClass: targetClass
		}
	];


	let vessels = AlertsStore.vesselGroup.vessels;
	let rawFilterString = AlertsStore.filters.filterString;
	let filtersUpdated = AlertsStore.filters.lastUpdated;
	let rawSelected = AlertsStore.vesselGroup.selected[VesselProperty.MMSI];
	$: {
		$rawFilterString;
		$rawSelected;
		$filtersUpdated;

		alertVessels = $vessels;
		AlertsStore.filters.lastUpdated.set(Date.now());
		updateFilter();
	}

	let updateFilter = () => {
		// console.log("updateFilter", $rawFilterString);
		if (typeof $rawFilterString === "undefined") {
			return;
		}
		const splitValues = StringHelper.splitByCommaOrSpace($rawFilterString.toLowerCase());

		alertVesselsTableRows = [];
		alertVessels.forEach(vessel => {
			if (!AlertsStore.helpers.isVesselVisibleForAlertFilters(vessel)) {
				return;
			}
			vessel.alertTypes.forEach(alertType => {
				alertVesselsTableRows.push({
					focus: "",
					name: vessel.name,
					imo: vessel.imo,
					mmsi: vessel.mmsi,
					alertType: alertType,
					selected: vessel.selected //AlertsStore.helpers.isVesselIMOSelected(vessel.imo)
				});
			});
		});

		// TODO: Review placement of filter truth function for finding vessels with imo in list
		// alertVesselsTableRows = FilterHelper.filterTableDataByIMOList(alertVesselsTableRows, splitImos);
		alertVesselsTableRows = FilterHelper.filterTableDataByPropertyList(alertVesselsTableRows, splitValues, ["mmsi", "imo", "name"]);
		alertVesselsTableRows = alertVesselsTableRows.filter(FilterHelper.filterAlertRowByVisibleAlertTypes);

		// console.log("alertVessels", alertVessels.length);
		// console.log("alertVesselsTableRows", alertVesselsTableRows.length);

	};

	let selectAll = () => {
		const imos = alertVesselsTableRows.map((v) => {
			return v.imo;
		});
		const vessels = AlertsStore.vesselGroup .filter((vessel) => { return imos.indexOf(vessel.imo) >= 0; });
		for(let i = 0; i < vessels.length; i++) {
			vessels[i].selected = true;
		};
		AlertsStore.vesselGroup.update();
	};
	let applyPaste = (inputValue) => {
		// This is kind of a filthy hax...
		if (inputValue.length > 2) {
			const splitValues = StringHelper.splitByCommaOrSpace(inputValue);
			if (alertVesselsTableRows.length === splitValues.length) {
				AlertsStore.vesselGroup.unfocusAll();
				AlertsStore.vesselGroup.deselectAll();
				for(let i = 0; i < splitValues.length; i++) {
					const vessel = AlertsStore.vesselGroup.find({[VesselProperty.MMSI]: alertVesselsTableRows[i].mmsi});
					vessel.selected = true;
					vessel.focused = true;
				}
				AlertsStore.vesselGroup.update();
			}
		}
	};
	let onFilterInput = (e) => {
		// console.log("onFilterInput", e);
		if (e.inputType === "insertFromPaste") {
			applyPaste(e.target.value);
		} 
		else if (e.inputType === "insertText") {
			applyPaste(e.target.value);
		}
	};
	let onFilterKeyUp = (e) => {
		// console.log("onFilterKeyUp", e);
		if (e.key === "Enter") {
			applyPaste(e.target.value);
		}
	};


	let gotoVesselHistory = () => {
		if (User.hasFeature(Feature.VESSEL_HISTORY.SEARCH_BY_MMSI)) {
			let mmsis = $rawSelected;
			Router.actions.gotoVesselHistoryForList(VesselIDType.MMSI, mmsis, 7, 0);
		}
		else {
			let mmsis = $rawSelected;
			let imos = AlertsStore.vesselGroup
							.filter((vessel)=>{ return mmsis.indexOf(vessel.mmsi) >= 0; })
							.map((vessel)=>{ return vessel.imo })
							.filter((imo) => { return imo != null })
							.filter((imo) => { return imo != "" });
			console.log(imos);

			Router.actions.gotoVesselHistoryForList(VesselIDType.IMO, imos, 7, 0);
		}


	};

</script>

<MenuItem title={"Current Alerts"} materialIcon={"directions_boat"}
		  class="query-component alert-list-component">
	<Textfield fullwidth dense variant="filled" bind:value={$rawFilterString} label="Filter table by IMO/MMSI/Name..."
			   on:input={onFilterInput} on:keyup={onFilterKeyUp}/>

	<div class="selection-list-element">
		<div class="alert-list-content mdc-elevation--z2">
			<MySvelteTable bind:this={table} on:clickCol={onColClick} on:clickCell={onCellClick} rows={alertVesselsTableRows}
						   columns={alertVesselsTableColumns} bind:sortBy={tableSortBy} bind:sortOrder={tableSortOrder} />
		</div>
		{#if $rawSelected.length > 1}
			<div><button class='btn-alertlist-vesselhistory bg-secondary' on:click={gotoVesselHistory}>Check Vessel History ({$rawSelected.length} selected)</button></div>
		{/if}
		
		<button class='btn-clear bg-error' on:click={clearSelected}>Clear Selection</button>
		{#if tableSortBy !== "selected" && $rawSelected.length > 0}
			<button class='btn-selectall bg-info' on:click={sortBySelected}>Sort By Selected</button>
		{/if}
		<button class='btn-selectall bg-primary' on:click={selectAll}>Select All</button>

		

		<!-- <Button on:click={clearSelected} variant="unelevated" class='btn-clear bg-error'>
			<Label>Clear Selection</Label>
		</Button>
		<Button on:click={selectAll} variant="unelevated" class='btn-selectall bg-primary'>
			<Label>Select All</Label>
		</Button> -->
	</div>

</MenuItem>
